export enum YES_NO {
  yes = 'yes',
  no = 'no'
}
export interface CallMeFormState {
  name: string;
  number: string;
  formErrors: {
    numValidity: 'VALID' | 'EMPTY' | 'INVALID';
    nameInvalid: boolean;
  };
  isCustomer: string;
  callMeActionStatusMessage: string;
  callMeActionStatus:
    | 'initial'
    | 'loading'
    | 'submittedSuccessfully'
    | 'submittedFailure';
}

export enum CallMeActionKind {
  SET_LOADING = 'SET_LOADING',
  SET_SUCCESS = 'SET_SUCCESS',
  SET_FAILURE = 'SET_FAILURE',
  SELECT_CUSTOMER_RELATIONSHIP = 'SELECT_CUSTOMER_RELATIONSHIP',
  ENTER_NAME = 'ENTER_NAME',
  ENTER_NUM = 'ENTER_NUM',
  VALIDATE_ENTER_NUM = 'VALIDATE_ENTER_NUM'
}

export type CallMeAction = {
  type: CallMeActionKind;
  payload: string;
};

export interface CallMeAppProps {
  additionalDataUrl: string | null | undefined;
}
